import { Box, Typography, Grid, IconButton } from "@mui/material";
import { motion } from "framer-motion";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from '@mui/icons-material/Instagram';

// Social Media Links
const socialLinks = [
    { icon: <GitHubIcon />, url: "https://github.com/Balzor" },
    { icon: <LinkedInIcon />, url: "https://linkedin.com/in/konstantinos-panteli" },
    { icon: <InstagramIcon />, url: "https://instagram.com/balzorgames" },
];

const LandingFooter = () => {
    return (
        <Box
            component="footer"
            sx={{
                // background: "#121212",
                color: "white",
                padding: '18px',
                paddingBottom: '30px',
                textAlign: "center",
            }}
        >
            <Grid container spacing={4} justifyContent="center">
                {/* Social Media */}
                <Grid item xs={12} md={12}>
                    <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                        Stay Connected
                    </Typography>
                    <Box display="flex" justifyContent="center" gap={2}>
                        {socialLinks.map((link, index) => (
                            <motion.div key={index} whileHover={{ scale: 1.2 }}>
                                <IconButton href={link.url} target="_blank" rel="noreferrer" sx={{ color: "white" }}>
                                    {link.icon}
                                </IconButton>
                            </motion.div>
                        ))}
                    </Box>
                </Grid>
            </Grid>

            {/* Legal Links & Copyright */}
            <Box sx={{ mt: 2, borderTop: "1px solid gray", pt: 3 }}>
                <Typography variant="body2" color="gray">
                    &copy; {new Date().getFullYear()} Konstantinos Panteli | Powered by Me
                </Typography>
            </Box>
        </Box>
    );
};

export default LandingFooter;
